import {
  MAX_FONT_SIZE,
  MAX_STROKE_THICKNESS,
  MIN_FONT_SIZE,
  MIN_STROKE_THICKNESS
} from 'consts/text'

export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max)

export const clampFontSize = (value: number): number =>
  clamp(value, MIN_FONT_SIZE, MAX_FONT_SIZE)

export const clampStrokeThickness = (value: number): number =>
  clamp(value, MIN_STROKE_THICKNESS, MAX_STROKE_THICKNESS)

/**
 * Scale `other` by the ratio derived from a single-sided change
 * (`oldValue` → `newValue`) and clamp the result.
 *
 * If either side of the ratio is 0 (old or new), the ratio is undefined or
 * would collapse `other` to 0, so `other` is returned unchanged — this keeps
 * "add a stroke to existing text" / "remove stroke" working without also
 * shrinking or blowing up the font.
 */
export const scaleProportional = (
  oldValue: number,
  newValue: number,
  other: number,
  clampFn: (value: number) => number
): number => {
  if (oldValue <= 0 || newValue <= 0) return other
  return clampFn(other * (newValue / oldValue))
}
